module.exports = __webpack_public_path__ + "static/media/covid.9b09986d.PNG";